/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToRem, mediaQuery } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION: COMMUNITY SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
    communitysection: {
        '& .collapsable.opened': {
            maxHeight: pxToRem(3000)
        },
        '& .field.name-title': {
            width: pxToRem(228),
            maxWidth: pxToRem(228)
        },
        '& .group.name-controls': {
            display: 'flex',
            flexFlow: 'wrap',
            '& .iconcontrol': {
                '& .content': {
                    width: '100%',
                    '& > img': {
                        maxWidth: pxToRem(64)
                    }
                },
                '& .triangle': {
                    right: '0 !important'
                }
            }
        }
    },
    // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
    [mediaQuery.thinnest]: { 
        communitysection: {
            '& .field.name-title': {
                width: '100%'
            },
            '& .group.name-controls': {
                '& > .iconcontrol': {
                    marginBottom: pxToRem(8)
                }
            }
        }
    }
});
